(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('religiousInstitution', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/religiousInstitution',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.html',
                    controller: 'ReligiousInstitutionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('religiousInstitution.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('religiousInstitution.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("religiousInstitutionForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();